import { addPopupAction, LAYER } from 'js/components/common/PopupManager';

import { ConfirmMarketingPreferencesPopup } from '../ConfirmMarketingPreferencesPopup';
import { POPUP_ID as id } from '../constants';

export const showConfirmMarketingPreferencesPopup = ({ ConfirmMarketingPreferencesParams }) => addPopupAction({
    id,
    layer: LAYER.HIGH_PRIORITY,
    component: ConfirmMarketingPreferencesPopup,
    ConfirmMarketingPreferencesParams
});
